import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/shape-5.png'
import _imports_1 from '@/assets/images/shape-7.png'
import _imports_2 from '@/assets/images/shape-6.png'


const _hoisted_1 = { class: "our-content-area ptb-100 bg-gondola3 position-relative z-1" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-lg-6 col-xl-7" }
const _hoisted_5 = { class: "our-content-img position-relative z-2 text-center text-lg-end" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  class: "col-lg-6 col-xl-5",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "200"
}
const _hoisted_8 = { class: "our-content position-relative z-1" }
const _hoisted_9 = { class: "top-title" }
const _hoisted_10 = { class: "text-white" }
const _hoisted_11 = { class: "text-silver" }
const _hoisted_12 = { class: "text-white" }
const _hoisted_13 = { class: "ps-0 list-unstyled content-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _ctx.c.image_url || _ctx.ourContentImg,
              alt: "our-content",
              "data-aos": "fade-up",
              "data-aos-duration": "1000",
              "data-aos-delay": "100"
            }, null, 8, _hoisted_6),
            _cache[0] || (_cache[0] = _createElementVNode("img", {
              src: _imports_0,
              class: "shape shape-5 z-1",
              alt: "shape"
            }, null, -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.c.top_title), 1),
            _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.c.title), 1),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.c.description), 1),
            _createElementVNode("p", null, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.c.highlight), 1)
            ]),
            _createElementVNode("ul", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.c.bullet_points, (point, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: i,
                  class: "d-flex align-items-center"
                }, [
                  _cache[1] || (_cache[1] = _createElementVNode("i", { class: "ti ti-circle-check" }, null, -1)),
                  _createElementVNode("span", null, _toDisplayString(point), 1)
                ]))
              }), 128))
            ]),
            _createVNode(_component_RouterLink, {
              to: "/world-cup-2026",
              class: "btn"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createElementVNode("span", { class: "border-style" }, "World Cup 2026 Guide", -1)
              ])),
              _: 1
            }),
            _cache[3] || (_cache[3] = _createElementVNode("img", {
              src: _imports_1,
              class: "shape shape-7",
              alt: "shape"
            }, null, -1))
          ])
        ])
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("img", {
      src: _imports_2,
      class: "shape shape-6",
      alt: "shape"
    }, null, -1))
  ]))
}